import * as React from 'react';

import SkillPathwayAttainmentsDataContext from 'bundles/skills-common/shared/verified-skills/context/skill-pathway/SkillPathwayAttainmentsDataContext';
import useGetOccupationGroupAndCareerBand from 'bundles/skills-common/shared/verified-skills/data/skill-pathway/useGetOccupationGroupAndCareerBand';
import useGetSkillAttainmentByOccupationGroupAndCareerBand from 'bundles/skills-common/shared/verified-skills/data/skill-pathway/useGetSkillAttainmentByOccupationGroupAndCareerBand';

type Props = {
  children: React.ReactNode;
  courseId: string;
  /** When true, skill attainment data fetching is skipped (e.g. practice / ungraded flows). */
  skip?: boolean;
};

const SkillPathwayAttainmentsDataProvider = ({ children, courseId, skip }: Props) => {
  const {
    occupationGroup,
    careerBand,
    loading: loadingOccupationGroupAndCareerBand,
  } = useGetOccupationGroupAndCareerBand({ courseId });

  const { skillAttainments, loading, refetchSkillAttainments } = useGetSkillAttainmentByOccupationGroupAndCareerBand({
    occupationGroupId: occupationGroup?.id,
    careerBand,
    skip,
  });

  return (
    <SkillPathwayAttainmentsDataContext.Provider
      value={{
        skillAttainments,
        refetchSkillAttainments,
        loading: loadingOccupationGroupAndCareerBand || loading,
      }}
    >
      {children}
    </SkillPathwayAttainmentsDataContext.Provider>
  );
};

export default SkillPathwayAttainmentsDataProvider;
